// import { useState, useEffect } from 'react'
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from './ui/dialog'
// import { Button } from './ui/button'
// import { Input } from './ui/input'
// import { Label } from './ui/label'

// interface RenameDialogProps {
//   open: boolean
//   onOpenChange: (open: boolean) => void
//   currentTitle: string
//   onConfirm: (newTitle: string) => void
// }

// export function RenameDialog({ open, onOpenChange, currentTitle, onConfirm }: RenameDialogProps) {
//   const [title, setTitle] = useState(currentTitle)

//   useEffect(() => {
//     setTitle(currentTitle)
//   }, [currentTitle])

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault()
//     if (title.trim()) {
//       onConfirm(title.trim())
//       onOpenChange(false)
//     }
//   }

//   return (
//     <Dialog open={open} onOpenChange={onOpenChange}>
//       <DialogContent className="bg-slate-900 border-slate-700">
//         <DialogHeader>
//           <DialogTitle className="text-white">Rename Chat</DialogTitle>
//           <DialogDescription className="text-slate-300">
//             Enter a new name for this conversation.
//           </DialogDescription>
//         </DialogHeader>
//         <form onSubmit={handleSubmit}>
//           <div className="space-y-4 py-4">
//             <div className="space-y-2">
//               <Label htmlFor="title" className="text-slate-200">
//                 Chat Name
//               </Label>
//               <Input
//                 id="title"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-400 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50"
//                 placeholder="Enter chat name"
//                 autoFocus
//               />
//             </div>
//           </div>
//           <DialogFooter>
//             <Button
//               type="button"
//               variant="ghost"
//               onClick={() => onOpenChange(false)}
//               className="text-slate-300 hover:text-white hover:bg-slate-800"
//             >
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               disabled={!title.trim()}
//               className="bg-blue-600 hover:bg-blue-700 text-white"
//             >
//               Rename
//             </Button>
//           </DialogFooter>
//         </form>
//       </DialogContent>
//     </Dialog>
//   )
// }

import React, { useState, useEffect } from 'react';
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import { Label } from '../../ui/label'

interface RenameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentTitle: string;
  onConfirm: (newTitle: string) => void;
}

export function RenameDialog({ open, onOpenChange, currentTitle, onConfirm }: RenameDialogProps) {
  const [title, setTitle] = useState(currentTitle);

  useEffect(() => {
    setTitle(currentTitle);
  }, [currentTitle]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (title.trim()) {
      onConfirm(title.trim());
      onOpenChange(false);
    }
  };

  if (!open) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-[250] flex items-center justify-center p-4"
        style={{ background: 'var(--scrim)' }}
        onClick={() => onOpenChange(false)} // Close modal on overlay click
      >
        {/* Modal content */}
        <div
          className="w-full max-w-lg border p-6"
          style={{
            background: 'var(--bg-modal)',
            borderColor: 'var(--border-md)',
            borderRadius: 'var(--r-xl)',
            boxShadow: 'var(--shadow-lg)',
            color: 'var(--text-primary)',
          }}
          onClick={e => e.stopPropagation()} // Prevent overlay closing when clicking inside modal
        >
          {/* Header */}
          <div className="mb-4">
            <h2 className="text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>Rename chat</h2>
            <p className="mt-2 text-sm" style={{ color: 'var(--text-muted)' }}>
              Enter a new name for this conversation.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="space-y-2 my-4">
              <Label htmlFor="title" style={{ color: 'var(--text-secondary)' }}>
                Chat name
              </Label>
              <Input
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter chat name"
                autoFocus
                className="border focus-visible:ring-0"
                style={{
                  background: 'var(--bg-input)',
                  borderColor: 'var(--border-md)',
                  color: 'var(--text-primary)',
                }}
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
                className="hover:opacity-95"
                style={{
                  background: 'var(--bg-card)',
                  borderColor: 'var(--border-md)',
                  color: 'var(--text-secondary)',
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={!title.trim()}
                className="text-white hover:opacity-95 disabled:opacity-60"
                style={{
                  background: 'var(--accent)',
                  borderColor: 'var(--accent)',
                }}
              >
                Rename
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
